import type { IconProps } from "@/types/IconProps";

export function Linkedin(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0M5.833 9.25a.083.083 0 0 0-.083.083V18c0 .046.037.083.083.083H8.5A.083.083 0 0 0 8.583 18V9.333A.083.083 0 0 0 8.5 9.25zm4.334 0a.09.09 0 0 0-.06.024.08.08 0 0 0-.024.059V18c0 .046.038.083.084.083h2.666a.084.084 0 0 0 .084-.083v-4.667a1.251 1.251 0 0 1 2.5 0V18c0 .046.037.083.083.083h2.667A.084.084 0 0 0 18.25 18v-5.747c0-1.618-1.407-2.883-3.017-2.737a4.8 4.8 0 0 0-1.446.365l-.87.374v-.922a.08.08 0 0 0-.024-.059.09.09 0 0 0-.06-.024zm-3-4a1.417 1.417 0 1 0 0 2.835 1.417 1.417 0 0 0 0-2.835"></path>
    </svg>
  );
}
